import { useState, useEffect, useCallback } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../FirebaseConfig';

/**
 * useTokenPacks
 *
 * Fetches the currently-saleable token packs from `listVisibleTokenPacks`
 * Cloud Function. Each entry includes server-computed `effectivePriceCents`
 * and `activeDiscount` (or null).
 *
 * Pack shape (relevant fields):
 *   { id, name, description, quantity, priceCents, effectivePriceCents,
 *     activeDiscount: {id,label,type,value,savings} | null,
 *     enabled, popular, displayOrder, art, imagePath, imageVariants }
 *
 * Returns: { packs, loading, error, reload }
 */
export function useTokenPacks() {
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const fn = httpsCallable(functions, 'listVisibleTokenPacks');
      const res = await fn({});
      const data = res.data || {};
      setPacks(Array.isArray(data.packs) ? data.packs : []);
    } catch (err) {
      console.error('[useTokenPacks] failed', err);
      setError(err.message || 'Failed to load token packs');
      setPacks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { packs, loading, error, reload };
}

export default useTokenPacks;
